import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Overlay from '../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import getLocale from '../../i18n/getLocale';

class PaymentHourEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      certification_supplier_id: '',
      training: '',
      date_start: '',
      date_finish: '',
      certification: '',
      supplier: '',
      hour_value: '',
      staff: '',
      hour_value: '',
      hours_paid: '',
      double_paid: "0,00",
      pnf_paid: "0,00",
      hours_total: '',
      supplier_id: '',
      certification_id: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.editPayment = this.editPayment.bind(this);

    this.locale = getLocale();
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleChangeHour (name, event) {
    var change = {};
    var valido = /^[\d,.]+$/.test(event.target.value);
    if (event.target.value === "" || valido === true) {
      var self = this;
      change[name] = event.target.value
      this.setState(change);
      window.setTimeout(function(){ 
        self.handleChangeHourTotal();
      }, 200);
    }
  }

  handleChangeHourTotal (name, event) {
    var hour_value = this.state.hour_value;

    if (this.state.hours_paid) {
      var hours_paid = parseFloat(this.state.hours_paid.replace(',', '.'));
    }
    if (this.state.pnf_paid) {
      var pnf_paid = parseFloat(this.state.pnf_paid.replace(',', '.'));
    }
    if (this.state.double_paid) {
      var double_paid = parseFloat(this.state.double_paid.replace(',', '.'));
    }

    if (isNaN(hours_paid)) {
      hours_paid = 0;
    }
    if (isNaN(pnf_paid)) {
      pnf_paid = 0;
    }
    if (isNaN(double_paid)) {
      double_paid = 0;
    }
    if (isNaN(hour_value)) {
      hour_value = 0;
    }
    
    var addition = pnf_paid + hours_paid + double_paid;
    var total = addition * hour_value;
    this.setState({hours_total: total.toFixed(2)});
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      if(typeof newProps.data_payment_hour.id !== 'undefined') {
        this.setState({
          training: newProps.data_payment_hour.training,
          date_start: newProps.data_payment_hour.date_start_str,
          date_finish: newProps.data_payment_hour.date_finish_str,
          certification: newProps.data_payment_hour.certification,
          supplier: newProps.data_payment_hour.supplier,
          certification_supplier: newProps.data_payment_hour.certification_supplier,
          staff: newProps.data_payment_hour.staff,
          hour_value: newProps.data_payment_hour.hour_value,
          hours_paid: newProps.data_payment_hour.hours_paid_value_str,
          double_paid: newProps.data_payment_hour.double_paid_str,
          pnf_paid: newProps.data_payment_hour.pnf_paid_str,
          hours_total: newProps.data_payment_hour.hours_total,
          id: newProps.data_payment_hour.id,
        });
      }
    }
  }

  // Fetch salvando a edição
  editPayment(event) {
    event.preventDefault();
    var datasave = {
      payment_type: 'hours',
      hours_paid: this.state.hours_paid,
      double_paid: this.state.double_paid,
      pnf_paid: this.state.pnf_paid,
      hours_total: this.state.hours_total,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({ modal: false });
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tituloEditarPagamento}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.editPayment}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formularioEditarPagamento.NomeDoTreinamento}:</label>
                    <input type="text" name="training" className="form-control" placeholder="" value={this.state.training} disabled="disabled" onChange={this.handleChange.bind(this, 'training')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formularioEditarPagamento.Aula}:</label>
                    <input type="text" name="certification" className="form-control" placeholder="" value={this.state.certification} disabled="disabled" onChange={this.handleChange.bind(this, 'certification')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formularioEditarPagamento.DataInicial}:</label>
                    <InputMask value={this.state.date_start} disabled="disabled" maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formularioEditarPagamento.DataFinal}:</label>
                    <InputMask value={this.state.date_finish} disabled="disabled" maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formularioEditarPagamento.Local}:</label>
                    <input type="text" name="certification_supplier" className="form-control" placeholder="" value={this.state.certification_supplier} disabled="disabled" onChange={this.handleChange.bind(this, 'certification_supplier')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formularioEditarPagamento.Tripulante}:</label>
                    <input type="text" name="staff" className="form-control" placeholder="" value={this.state.staff} disabled="disabled" onChange={this.handleChange.bind(this, 'staff')} />
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formularioEditarPagamento.HorasPagas}:</label>
                    <input type="text" required value={this.state.hours_paid} name="hours_paid" className="form-control" onChange={this.handleChangeHour.bind(this, 'hours_paid')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formularioEditarPagamento.HorasPNFPagas}:</label>
                    <input type="text" value={this.state.pnf_paid} name="pnf_paid" className="form-control" onChange={this.handleChangeHour.bind(this, 'pnf_paid')} placeholder="" />
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formularioEditarPagamento.HorasDobradas}:</label>
                    <input type="text" value={this.state.double_paid} name="double_paid" className="form-control" onChange={this.handleChangeHour.bind(this, 'double_paid')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formularioEditarPagamento.ValorHora}:</label>
                    <input value={this.state.hour_value} disabled="disabled" name="hour_value" className="form-control" onChange={this.handleChange.bind(this, 'hour_value')} placeholder="" />
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formularioEditarPagamento.TotalPago}:</label>
                    <input value={this.state.hours_total} disabled="disabled" name="hours_total" className="form-control" onChange={this.handleChange.bind(this, 'hours_total')} placeholder="" />
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formularioEditarPagamento.botaoSalvarPagamento}</button>
                </div>
              </div>
            </form>    
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default PaymentHourEditModal;



// WEBPACK FOOTER //
// ./src/Components/SchedulePayments/PaymentHourEditModal.js